var _path, _path2, _path3, _polygon, _polygon2, _polygon3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Quality_control") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Quality_control"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.7,39V468.74h-254c-33,0-42.87-19.56-42.87-43.7V39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.45,469.41h30.79c20.11,0,36.41-17.41,36.41-38.87h-251c0,21.46-16.31,38.87-36.42,38.87Z",
    style: {
      fill: "#9dc0d1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.84,
    y: 187.82,
    width: 42.25,
    height: 42.25,
    style: {
      fill: "#3dc9c9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.84,
    y: 264.14,
    width: 42.25,
    height: 42.25,
    style: {
      fill: "#3dc9c9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.84,
    y: 339.04,
    width: 42.25,
    height: 42.25,
    style: {
      fill: "#3dc9c9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.68,
    y: 90.94,
    width: 56.29,
    height: 12,
    style: {
      fill: "#def1f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.68,
    y: 113.84,
    width: 98.99,
    height: 12,
    style: {
      fill: "#def1f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.68,
    y: 136.59,
    width: 98.99,
    height: 12,
    style: {
      fill: "#def1f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.67,
    y: 288.53,
    width: 96.67,
    height: 12,
    style: {
      fill: "#83afc6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.67,
    y: 364.85,
    width: 96.67,
    height: 12,
    style: {
      fill: "#83afc6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.91 141.03 371.91 203.62 394.24 190.79 416.57 203.62 416.57 141.03 371.91 141.03",
    style: {
      fill: "#ffaf9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.27,95.69c-2.12-5.09,1.11-13.9-2.73-17.74s-12.64-.61-17.74-2.72c-4.91-2-8.81-10.62-14.46-10.62s-9.56,8.58-14.47,10.62c-5.09,2.11-13.9-1.12-17.74,2.72s-.61,12.65-2.72,17.74c-2,4.91-10.62,8.81-10.62,14.46s8.58,9.56,10.62,14.47c2.11,5.09-1.12,13.9,2.72,17.74s12.65.61,17.74,2.72c4.91,2,8.82,10.62,14.47,10.62s9.55-8.58,14.46-10.62c5.1-2.11,13.91,1.12,17.74-2.72s.61-12.65,2.73-17.74c2-4.91,10.61-8.81,10.61-14.47S430.3,100.6,428.27,95.69Z",
    style: {
      fill: "#f47a53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.92 132.91 368.6 116.59 377.08 108.1 384.92 115.94 409.22 91.64 417.71 100.13 384.92 132.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.6 300.28 211.6 189.9 116 134.7 20.41 189.9 20.41 300.27 63.92 325.4 70.65 329.28 116 355.47 211.6 300.28",
    style: {
      fill: "#f47a53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.59 189.62 116 244.82 20.41 189.62 116 134.43 211.59 189.62",
    style: {
      fill: "#ffaf9f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.88 209.18 177.88 319.56 149.07 336.19 149.07 225.05 54.13 170.24 82.28 153.98 177.88 209.18",
    style: {
      fill: "#def1f9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116 392.34 60.68 360.39 66.68 350 116 378.48 159.31 353.48 165.31 363.87 116 392.34",
    style: {
      fill: "#3dc9c9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.21,
    y: 335.1,
    width: 12,
    height: 18.87,
    transform: "translate(-275.77 211.41) rotate(-60)",
    style: {
      fill: "#3dc9c9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476,
    y: 155.7,
    width: 12,
    height: 24.3,
    style: {
      fill: "#3dc9c9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476,
    y: 33,
    width: 12,
    height: 110.5,
    style: {
      fill: "#3dc9c9"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.06,304.27V186.43L116,127.5,14,186.43V304.26L116,363.19Zm-74.63-67.83v97.05L122,345.86V248.81Zm12-6.93,16.8-9.7v97.06l-16.8,9.69Zm-5.34-10.77L66,170.21l16.15-9.32,84,48.53Zm-12,6.93L116,238.42,32,189.89,54,177.14Zm46.14,84.27V212.88l21.83-12.6v97.06Zm15.83-120-21.83,12.6L94.18,154,116,141.36ZM26,200.28,110,248.81v97.06L26,297.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M465.53,33H175.81V141h12V45H453.53V425.51H247v6a29.58,29.58,0,1,1-59.15,0V356.26h-12v75.26a42.4,42.4,0,0,0,40.93,42.19v0H466.43a42.27,42.27,0,0,0,42.22-42.23v-6H465.53Zm.9,428.74H246.18a42.09,42.09,0,0,0,12.35-24.23H496.05A30.27,30.27,0,0,1,466.43,461.74Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M349.37,97.19c-3.38,3.16-7.58,7.09-7.58,13s4.2,9.81,7.58,13c1.32,1.23,3.13,2.92,3.5,3.8s.34,3.49.29,5.48c-.13,4.54-.29,10.19,3.73,14.2a13.15,13.15,0,0,0,8.12,3.6V214l28.33-16.28L421.67,214V150.2a13.17,13.17,0,0,0,8.12-3.6c4-4,3.85-9.66,3.73-14.2-.06-2-.13-4.47.29-5.48s2.17-2.57,3.49-3.8c3.38-3.16,7.58-7.09,7.58-13s-4.2-9.8-7.58-13c-1.32-1.23-3.13-2.93-3.49-3.8s-.35-3.49-.29-5.48c.12-4.54.28-10.19-3.73-14.21s-9.67-3.85-14.2-3.72c-2,0-4.48.12-5.49-.3s-2.57-2.17-3.8-3.49c-3.16-3.38-7.09-7.58-13-7.58s-9.81,4.2-13,7.58c-1.23,1.32-2.92,3.13-3.8,3.49s-3.49.35-5.48.3c-4.54-.13-10.19-.29-14.2,3.72s-3.86,9.67-3.73,14.21c0,2,.12,4.47-.29,5.48S350.69,96,349.37,97.19Zm44,86.68L377,193.25V150.88a26.85,26.85,0,0,1,3.36,3.24c3.16,3.38,7.1,7.58,13,7.58s9.8-4.2,13-7.58a26.2,26.2,0,0,1,3.37-3.24v42.37ZM357.57,106c2.35-2.21,5-4.7,6.38-8s1.3-7.12,1.2-10.42c0-1.67-.12-4.41.25-5.35.94-.37,3.68-.3,5.35-.25,3.3.09,7,.2,10.42-1.2s5.77-4,8-6.38c1.15-1.23,3.27-3.5,4.2-3.77.93.27,3.05,2.54,4.19,3.77,2.21,2.35,4.7,5,8,6.38s7.12,1.29,10.42,1.2c1.67,0,4.41-.12,5.35.25.37.94.3,3.68.25,5.35-.09,3.3-.2,7,1.2,10.42s4,5.76,6.38,8c1.23,1.15,3.5,3.26,3.77,4.19-.27.94-2.54,3-3.77,4.2-2.35,2.21-5,4.7-6.38,8s-1.29,7.12-1.2,10.42c.05,1.67.12,4.41-.25,5.35-.94.37-3.68.3-5.35.25-3.3-.09-7-.2-10.42,1.2s-5.76,4-8,6.38c-1.14,1.23-3.26,3.5-4.19,3.77-.93-.27-3-2.54-4.2-3.77-2.2-2.35-4.7-5-8-6.38a20.36,20.36,0,0,0-7.82-1.25c-.89,0-1.76,0-2.6.05-1.67,0-4.4.12-5.35-.25-.37-.94-.29-3.68-.25-5.35.1-3.3.2-7-1.2-10.42s-4-5.76-6.38-8c-1.23-1.15-3.49-3.26-3.77-4.2C354.08,109.22,356.34,107.11,357.57,106Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "296.09 198.15 284.09 198.15 284.09 224.07 253.84 224.07 253.84 193.82 274.24 193.82 274.24 181.82 241.84 181.82 241.84 236.07 296.09 236.07 296.09 198.15"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "296.09 274.47 284.09 274.47 284.09 300.39 253.84 300.39 253.84 270.14 274.24 270.14 274.24 258.14 241.84 258.14 241.84 312.39 296.09 312.39 296.09 274.47"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "274.24 346.46 274.24 334.46 241.84 334.46 241.84 388.71 296.09 388.71 296.09 350.79 284.09 350.79 284.09 376.71 253.84 376.71 253.84 346.46 274.24 346.46"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 333.67,
    y: 300.39,
    width: 96.67,
    height: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 333.67,
    y: 276.66,
    width: 96.67,
    height: 12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 333.67,
    y: 376.71,
    width: 96.67,
    height: 12
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 333.67,
    y: 352.98,
    width: 96.67,
    height: 12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 212.68,
    y: 79.77,
    width: 56.29,
    height: 12
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 212.68,
    y: 102.67,
    width: 98.99,
    height: 12
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 212.68,
    y: 125.42,
    width: 98.99,
    height: 12
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "299.43 178.64 273.08 204.99 265.25 197.15 256.77 205.64 273.08 221.96 307.92 187.13 299.43 178.64",
    style: {
      fill: "#f47a53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.25 273.47 256.77 281.96 273.08 298.27 307.92 263.44 299.43 254.96 273.08 281.3 265.25 273.47",
    style: {
      fill: "#f47a53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.43 331.28 273.08 357.62 265.25 349.79 256.77 358.28 273.08 374.59 307.92 339.76 299.43 331.28",
    style: {
      fill: "#f47a53"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/품질팀.a1a7839334e8ba32bbc831ff9b1fe1bd.svg";
export { ForwardRef as ReactComponent };